module.exports = coreApis.componentApis.utils.categories.data;